import {html, LitElement, nothing} from "lit";
import {customElement, property} from "lit/decorators.js";
import "./ToggleButtonProQuest.js";
import "./ToggleButtonEBSCO.js";
import "./ToggleButtonGale.js";
import Integration from "../../../integrations/integration/index.js";

@customElement("pn-toggle-button")
export class ToggleButton extends LitElement {
	@property({type: Boolean}) isSidebarHidden = false;

	render() {
		switch (Integration.name) {
			case "proquest":
				return html`
					<pn-toggle-button-proquest/>
				`;

			case "ebsco":
				return html`
					<pn-toggle-button-ebsco/>
				`;

			case "gale":
				return html`
					<pn-toggle-button-gale/>
				`;

			default:
				if (!this.isSidebarHidden)
					return nothing;

				// TODO: implement
				return html`
					<button>Toggle PowerNotes sidebar</button>
				`;
		}
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"pn-toggle-button": ToggleButton;
	}
}
